module.exports = __webpack_public_path__ + "static/media/wb_webhook_page.de8306c0.png";